import React, { useEffect } from 'react';
import './App.css';
import { Route, Routes, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import logo from './Assets/memlogo.png'
import Home from './Pages/Home.js'
import About from './Pages/About.js'
import IntakeForm from './Pages/IntakeForm.js';
import Account from  './Pages/Account.js';
import Blog from './Pages/Blog.js';
import ContactForm from './Pages/ContactForm.js';
import Order from './Pages/OrderManual.js';
import Admin from './Pages/Admin.js';
import PrivacyPolicy from './Pages/PrivacyPolicy.js';
import TermsOfServicePage from './Pages/TermsOfService.js';
import Subprocessors from './Pages/Subprocessors.js';
import DoNotSell from './Pages/DoNotSell.js';

function App() {
  const location = useLocation();
  const { user, loginWithRedirect, logout, isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  // Per-route page titles. Falls back to a sensible default.
  useEffect(() => {
    const titles = {
      '/': 'MyEmployeeManual.com — State-Compliant Employee Handbooks',
      '/intake': 'Build Your Employee Manual — MyEmployeeManual.com',
      '/blog': 'Blog — MyEmployeeManual.com',
      '/account': 'Account — MyEmployeeManual.com',
      '/contact': 'Contact Us — MyEmployeeManual.com',
      '/order': 'Order — MyEmployeeManual.com',
      '/admin': 'Admin — MyEmployeeManual.com',
      '/privacyPolicy': 'Privacy Policy — MyEmployeeManual.com',
      '/tos': 'Terms of Service — MyEmployeeManual.com',
      '/subprocessors': 'Subprocessors — MyEmployeeManual.com',
      '/do-not-sell-or-share': 'Do Not Sell or Share — MyEmployeeManual.com',
    };
    document.title = titles[location.pathname] || 'MyEmployeeManual.com';
  }, [location.pathname]);

  // Global Privacy Control detection. Persists an opt-out flag in localStorage
  // so any downstream component can read mem_gpc_optout === '1' and skip
  // sale/sharing-grade tracking.
  useEffect(() => {
    if (typeof navigator !== 'undefined' && navigator.globalPrivacyControl) {
      try { localStorage.setItem('mem_gpc_optout', '1'); } catch {}
    }
  }, []);

  function accButton(){
    if (isAuthenticated) {
        return(
          <Link to="/account" className='tab'><p>Account</p></Link>
        );
    }else{
      return(<div></div>);
    }
  }

  function checkAuth(){
      if (isAuthenticated) {
          return "Sign Out"
      } else {
          return "Sign In"
      }
  }


  if(!(location.pathname==="/")){
    return (
      <div className="App">
        <div className="navbar">
          <div className='imgContainer'>
              <Link to="/">
                  <img src={logo} alt='MEM Logo' className="logo"/>
              </Link>
          </div>
          <Link to="/" className='tab'><p>Home</p></Link>
          <Link to="/contact" className='tab'><p>Contact Us</p></Link>
          {accButton()}
          <div className='navbarRight'>
            <button onClick={() => isAuthenticated ? logout() : loginWithRedirect()} className='tab'><p>{checkAuth()}</p></button>
          </div>
        </div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/intake" element={<IntakeForm />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/account" element={<Account />} />
          <Route path="/account/refresh" element={<Account />} />
          <Route path="/images/logo" element={<img src={logo} alt="MEM Logo" />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/order" element={<Order />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/tos" element={<TermsOfServicePage />} />
          <Route path="/subprocessors" element={<Subprocessors />} />
          <Route path="/do-not-sell-or-share" element={<DoNotSell />} />
        </Routes>
      </div>
    );
  }else{
    return(
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    );
  }
}

export default App;
